module.exports = __webpack_public_path__ + "applabtutorialwp7ff5dc0637a5366ee15ed33f55e46275.png";